/* global axios */
// NOTICE: KAPTION-INTEGRATION

import ApiClient from './ApiClient';

class KaptionResponsePoliciesAPI extends ApiClient {
  constructor() {
    super('kaption_response_policies', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  getMetrics(params) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  getMissed(params) {
    return axios.get(`${this.url}/missed`, { params });
  }

  download(params) {
    return axios.get(`${this.url}/download`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new KaptionResponsePoliciesAPI();
